/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LightFacesPainScaleAliases {
  CONTEXTUAL_BAR_LIGHT_FACES = 'contextual-bar-light-faces',
  LAYOUT_LIGHT_FACES = 'layout-light-faces',
  PAIN_SCALE_LIGHT_FACES = 'pain-scale-light-faces',
  PANEL_LIGHT_FACES = 'panel-light-faces',
}
export { LightFacesPainScaleAliases };
